import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';
import api from './api';
import { AxiosRequestConfig } from 'axios';

type ApiMethods = 'post' | 'put' | 'patch' | 'delete';

export const useMutationByMethod = <T>(
  method: ApiMethods,
  endpoint: string,
  config?: AxiosRequestConfig
): UseMutationResult<T, { status: number; data: any }, any> => {
  const queryClient = useQueryClient();

  return useMutation<T, { status: number; data: any }, any>({
    mutationFn: async (data: any) => {
      try {
        const response = await api.request<T>({
          method,
          url: endpoint,
          data,
          ...config,
        });
        return response.data;
      } catch (error: any) {
        if (error.response) {
          const status = error.response.status;
          const data = error.response.data;
          throw { status, data };
        }
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [endpoint] });
    },
    onError: (error) => {
      // Optional centralized handler
    },
  });
};
